import Drawer from 'react-modern-drawer';
import { useEffect, useState } from "react";
import CueProductUpsert from "./cueProduct_upsert";
import metaDataServices from "../MetaDataServices";
import ExistingSong from '../Song/ExistingSong';
import { ContactFormSearch } from 'components/Contacts/contactFormSearch';

export default function AddCueSongUpsert(param: any) {

    console.log(param)

    let [isOpen, setIsOpen] = useState(param.AddSongToCue);
    let [songDetailSelect, SetSongDetailSelect] = useState<any>([]);
    let [songSplitslistIPI, SetSongSplitslistIPI] = useState<any>([]);
    let [openSongListing, setOpenSongListing] = useState(false);
    var payLoad = {
        pageNumber: 1,
        pageSize: 10,
        songID: ''
    }

    var cueSongsPayload = {
        pageNumber: 1,
        pageSize: 10,
        cueNumber: ''

    }
    let [cueSongsList, SetcueSongsList] = useState<any>([]);
    useEffect(() => {

        cueSongsPayload.cueNumber = param.cueSelected.cueId
        metaDataServices.cueSongsList(cueSongsPayload).then((res:any) => {
            cueSongsList = res
            SetcueSongsList(cueSongsList);
        })
    }, [param])

    const closeSongListing = (e: any) => {

        songDetailSelect = e;
        SetSongDetailSelect(songDetailSelect)
        if (e && e.songID) {
            payLoad.songID = e.songID;
            metaDataServices.songSplitslistIPI(payLoad).then((res:any) => {
                songSplitslistIPI = res
                SetSongSplitslistIPI(songSplitslistIPI);

            })
        }
        console.log(e)
        openSongListing = false;
        setOpenSongListing(openSongListing);
    }

    const onCloseDrawer = () => {
        param.onChangeAddSongToCue();
    }

    const resetCueUpsertForm = () => {
        songDetailSelect = [];
        SetSongDetailSelect(songDetailSelect)

        songSplitslistIPI = [];
        SetSongSplitslistIPI(songSplitslistIPI)
    }

    var cueData = {
        cueBase: null,
        cueComments: null,
        cueDurationMinute: 0,
        cueDurationSecond: 0,
        cueLibrary: null,
        cueLinkId: 0,
        cueName: null,
        cueNumber: null,
        cueSequence: "2",
        cueSharePercent: 100,
        cueSsN: null,
        cueTheme: null,
        cueTiS: null,
        cutNumber: null,
        iPaffiliation: null,
        iPcomments: null,
        iPcompanyName: null,
        iPfirstName: "",
        iPlastName: "",
        iPmiddleName: null,
        iProle: "",
        interestedPartyId: null,
        masterUseLicenseIndicator: null,
        masterUseLicensor: "",
        publicDomainTerritory: "",
        songDuration: null,
        songId: "",
        songTitle: "FOX FANFARE",
        syncLicenseIndicator: null,
        visualSource: null,
        syncLicensor: ''
    };

    const saveCueUpsertForm = () => {
        cueData.publicDomainTerritory = 'WW';
        cueData.visualSource = null;
        cueData.cueLibrary = null;
        cueData.cutNumber = null;
        cueData.syncLicenseIndicator = null;
        cueData.masterUseLicenseIndicator = null;
        cueData.cueComments = null;
        cueData.iPmiddleName = null;
        cueData.iPcompanyName = null;
        cueData.cueSsN = null;
        cueData.cueBase = null;
        cueData.cueTiS = null;
        cueData.iPcomments = null;

        console.log(songDetailSelect)
        console.log(param.cueSelected)
        console.log(songSplitslistIPI)

        var payload = []
        for (var i = 0; i < songSplitslistIPI.length; i++) {
            cueData.cueDurationMinute = songDetailSelect.cueDurationMinute;
            cueData.cueDurationSecond = songDetailSelect.cueDurationSecond;
            cueData.cueLinkId = 0;
            cueData.cueName = param.cueSelected.masterCue;
            cueData.cueNumber = param.cueSelected.masterCue;
            cueData.cueSequence = songDetailSelect.cueSequence;
            cueData.cueSharePercent = songSplitslistIPI[i].split ?? 0;
            cueData.cueTheme = param.cueSelected.cueTheme;
            cueData.iPaffiliation = songSplitslistIPI[i].affiliation;
            cueData.iPfirstName = songSplitslistIPI[i].firstName ?? "";
            cueData.iPlastName = songSplitslistIPI[i].lastName ?? "";
            cueData.iProle = songSplitslistIPI[i]?.role;
            cueData.interestedPartyId = songSplitslistIPI[i].iPnumber ?? "";
            cueData.masterUseLicensor = songDetailSelect.masterUseLicensor;
            cueData.syncLicensor = songDetailSelect.syncLicensor;
            cueData.songDuration = songDetailSelect.songID;
            cueData.songId = songDetailSelect.songID;
            cueData.songTitle = songDetailSelect.songName;
            payload.push(cueData)
        }

        console.log(payload)

    }

    const reportCueSong = () => {

        if (param.cueSelected.masterCue) {

            var url = "/Api/CrystalReport/CrystalReport802.aspx?template=Reports/Crystal802.rpt&format=pdf&masterCue=" + param.cueSelected.masterCue;
            window.open(url);
        }
    }

    let [dialogueAddOpenView, setdialogueAddOpenView] = useState(false);
    const onChangeMasterUseLicensor = (e: any) => {
        console.log(e)
        songDetailSelect.masterUseLicensorCode = e.kontactCode
        songDetailSelect.masterUseLicensor = e.kontactDisplay;
        SetSongDetailSelect({ ...songDetailSelect });
        console.log(songDetailSelect)
    }

    const onChangeContactSyncLicensor = (e: any) => {
        console.log(e)
        songDetailSelect.syncLicensorCode = e.kontactCode
        songDetailSelect.syncLicensor = e.kontactDisplay
        //SetSongDetailSelect(songDetailSelect)
        SetSongDetailSelect({ ...songDetailSelect });
        console.log(songDetailSelect)
    }

    return (<>
        <Drawer open={isOpen}
            onClose={() => setIsOpen(false)}
            direction='right'
            className='react-drawer allowHscroll allowVscroll'
            size={800}>
            <div className="box noBorderRadius noBorder ws-8 pull-right pLanding">

                <div className='landing ws-12'>

                    <div className="box-header  noBorderRadius bg-blue pLarge">Link Cue to Songs </div>

                    <div className="ws-12 pt pll prl">
                        <fieldset className="scheduler-border ps">
                            <legend className="scheduler-border">
                                <h2 style={{ color: "#47529d" }} >
                                    <i className="fa fa-sticky-note-o"></i> Cue Info
                                </h2>
                            </legend>

                            <div className="ws-12 pm">

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Master Cue :</label>
                                        <div className="label-entries ws-8">{param.cueSelected.masterCue ?? ""} </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Type :</label>
                                        <div className="label-entries ws-8"> {param.cueSelected.cueSheetType ?? ""}</div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Runtime : </label>
                                        <div className="label-entries ws-8">
                                            {String(param.cueSelected.runtimeDurationMinute).padStart(2, '0')} : {String(param.cueSelected.runtimeDurationSecond).padStart(2, '0')}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="ws-12 pm">

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Sub Usage:</label>
                                        <div className="label-entries ws-8">{param.cueSelected.cueSubUsage ?? ""} </div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Cue Theme :</label>
                                        <div className="label-entries ws-8">{param.cueSelected.cueTheme ?? ""}</div>
                                    </div>
                                </div>

                                <div className="ws-4">
                                    <div className="ws-12">
                                        <label className="text-bold ws-4 text-right pr">Cue Usage : </label>
                                        <div className="label-entries ws-8">{param.cueSelected.cueUsage ?? ""}</div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className="ws-12 pb pll prl ">
                        <div className='box '>
                            <div className="box-header well mb">
                                <h2><strong>Songs</strong> </h2>
                            </div>

                            <div className="ws-6 pm">

                                <div className="ws-12 pm">
                                    <label className="text-bold ws-12" htmlFor="songTitle">
                                        Song Title
                                    </label>
                                    <div className="label-entries">
                                        <input className="ws-12" id="songTitle" name="songTitle" type="text" placeholder="Song Title" value={songDetailSelect?.songName ?? ""}  onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, songName: e.target.value, })}/>
                                    </div>
                                </div>

                                <div className="ws-12 pm">
                                    <label className="text-bold ws-12" htmlFor="songId">Song ID  </label>
                                    <div className="label-entries">
                                        <div className="ws-8">
                                            <input className="ws-12" id="songId" name="songId" type="text" disabled={true} placeholder="Song ID" value={songDetailSelect?.songID ?? ""} />
                                        </div>
                                        <div className="ws-4 pull-right">
                                            <button type="button" className="icon-btn info pull-right pbl" onClick={() => setOpenSongListing(true)}>Choose a Song</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-12 pm">
                                    <label className="text-bold ws-12" htmlFor="songDuration"> Song Duration  </label>
                                    <div className="label-entries">
                                        <input className="ws-12 text-right" id="songDuration" name="songDuration" type="text" placeholder="Song Duration" value={songDetailSelect?.songDuration ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, songDuration: e.target.value, })}/>
                                    </div>
                                </div>

                                <div className="ws-12 pm">
                                    <label className="text-bold ws-12" htmlFor="masterUseLicensor">
                                        Master Use Licensor
                                    </label>
                                    <div className="label-entries">
                                        <div className="ws-10">
                                            <input className="ws-12" id="masterUseLicensor" name="masterUseLicensor" type="text" disabled={true} placeholder="Master Use Licensor" value={songDetailSelect?.masterUseLicensor  ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, masterUseLicensor: e.target.value, })}/>
                                        </div>
                                        <div className="ws-2">
                                            <ContactFormSearch onChange={onChangeMasterUseLicensor} data={""} open={dialogueAddOpenView} />
                                        </div>
                                    </div>

                                </div>

                                <div className="ws-12 pm">
                                    <label className="text-bold ws-12" htmlFor="syncLicensor">Sync Licensor </label>
                                    <div className="label-entries">
                                        <div className="ws-10">
                                            <input className="ws-12" id="syncLicensor" name="syncLicensor" type="text" placeholder="Sync Licensor" disabled={true} value={songDetailSelect?.syncLicensor  ?? ""} />
                                        </div>
                                        <div className="ws-2">
                                            <ContactFormSearch onChange={onChangeContactSyncLicensor} data={""} open={dialogueAddOpenView} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {(songSplitslistIPI.length > 0) && <div className="ws-6 pm">
                                <div className="box-content form-box text-center">
                                    <div className="row-fluid"></div>

                                    {songSplitslistIPI.map((value: any) => {

                                        return (

                                            <div className="ws-5 mb mr">
                                                <div className="box box-dash box-primary">
                                                    <div className="box-header pr text-center ws-12" style={{ height: "4em" }}>{value.kontactCodeDisplay} </div>
                                                    <div className="box-content pm">

                                                        {value.iPnumber && <div className='ws-12 border-bottom pb'>
                                                            <span className='text-bold pull-left'>IP number:</span>
                                                            <span className='pull-right'> {value.iPnumber}</span>
                                                        </div>}

                                                        {value.split && <div className='ws-12 border-bottom pb'>
                                                            <span className='text-bold pull-left'>Share %:</span>
                                                            <span className='pull-right'> {value.split}</span>
                                                        </div>}

                                                        {value.role && <div className='ws-12 border-bottom pb'>
                                                            <span className='text-bold pull-left'>Role:</span>
                                                            <span className='pull-right'> {value.role}</span>
                                                        </div>}

                                                        {value.affiliation && <div className='ws-12 border-bottom pb'>
                                                            <span className='text-bold pull-left'>Affiliation:</span>
                                                            <span className='pull-right'> {value.affiliation}</span>
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>}
                        </div>
                    </div>

                    <div className="ws-12 pm ">

                        <div className='box '>

                            <div className="box-header well mb">
                                <h2>Cue Song Entry</h2>
                            </div>

                            <div className="ws-12 pm">
                                <div className="ws-6 pm">
                                    <label className="ws-12 text-bold" htmlFor="cueSequence">
                                        Cue Sequence
                                    </label>
                                    <div className="label-entries">
                                        <input className="ws-12" id="cueSequence" name="cueSequence" type="text" placeholder="Cue Sequence" value={songDetailSelect?.cueSequence ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, cueSequence: e.target.value, })}/>
                                    </div>
                                </div>

                                <div className="ws-6 pm">
                                    <label className="ws-12 text-bold" htmlFor="cueNumber">
                                        Cue Number
                                    </label>
                                    <div className="label-entries">
                                        <input className="ws-12" id="cueNumber" name="cueNumber" type="text" placeholder="Cue Number" value={songDetailSelect?.cueNumber ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, cueNumber: e.target.value, })}/>
                                    </div>
                                </div>

                                <div className="ws-6 pm">
                                    <label className="ws-12 text-bold" htmlFor="cueTheme">
                                        Cue Theme
                                    </label>
                                    <div className="label-entries">
                                        <input className="ws-12" id="cueTheme" name="seriesProductionNum" type="text" placeholder="Cue Theme" value={songDetailSelect?.cueTheme ??""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, cueTheme: e.target.value, })}/>
                                    </div>
                                </div>

                                <div className="ws-6 pm">
                                    <label className="ws-12 text-bold" htmlFor="programDurationMinute">
                                        Song Cue Duration
                                    </label>
                                    <div className="ws-12">
                                        <input className="form-control w-49 text-right" id="programDurationMinute" name="programDurationMinute" type="text" placeholder="Minutes" value={songDetailSelect?.cueDurationMinute ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, cueDurationMinute: e.target.value, })}/>
                                        <input className="form-control w-49 text-right pull-right" id="programDurationSecond" name="programDurationSecond" type="text" placeholder="Seconds" value={songDetailSelect?.cueDurationSecond ?? ""} onChange={(e: any) => SetSongDetailSelect({ ...songDetailSelect, cueDurationSecond: e.target.value, })}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="ws-12 pm ">
                        <div className="ws-12 pm ">
                            <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>
                            <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                            <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                            <button type="button" className="icon-btn info  pull-right" onClick={() => reportCueSong()}><i className='icon-file-add' /> Report Cue Song</button>
                        </div>

                    </div>

                    <div className="ws-12 pm hide">
                        <div className='ws-12 box '>

                            <div className="ws-12 box-header well mb">
                                <h2>Songs Linked to cue</h2>
                            </div>

                            <div className='ws-12 pLarge'>
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>Song Title</th>
                                            <th>Cue Number</th>
                                            <th>Song Cue Duration</th>
                                            <th>Cue Theme</th>
                                            <th>Share %</th>
                                            <th>IP Person</th>
                                            <th>IP Number</th>
                                            <th>Affiliation</th>
                                            <th>Operation</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {cueSongsList.map((row: any) => (
                                            <tr>
                                                <td>{row.songTitle}</td>
                                                <td>{row.cueNumber}</td>
                                                <td>{String(row.cueDurationMinute).padStart(2, '0')} : {String(row.cueDurationSecond).padStart(2, '0')} </td>
                                                <td>{row.cueTheme}</td>
                                                <td>{row.cueSharePercent}</td>
                                                <td>{row.iPfirstName}</td>
                                                <td>{row.interestedPartyId}</td>
                                                <td>{row.iPaffiliation}</td>
                                                <td>
                                                    <button className="icon-btn delete" title="Delete" type="button">
                                                        <i className="icon-trash"> </i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>

                        </div>
                    </div>

                </div>

                {
                    (() => {
                        if (openSongListing) {
                            return <ExistingSong closeSongListing={closeSongListing} SongListingOpen={openSongListing} />
                        }

                    })()
                }
            </div>
        </Drawer>
    </>)
}